import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import { createWidget } from '../helpers/jira';
import Forgotten from './auth/Forgotten';
import Login from './auth/Login';
import Reset from './auth/Reset';
import Panes from './views/Panes';

const App = () => {
    const [loading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch('/config.json')
            .then(response => response.json())
            .then(response => {
                sessionStorage.setItem('base_url', response.base_url);
                setTimeout(() => setIsLoading(false), 500)

                if (response.optionShowSupportWidget) {
                    createWidget(response.supportWidgetKey);
                }
            })
    }, [loading])

    if (loading) {
        return <Loader active />
    }

    return (
        <BrowserRouter>
            <Switch>
                <Route path="/forgotten" component={Forgotten} />
                <Route path="/reset" component={Reset} />
                <Route path="/dashboard" component={Panes} />
                <Route exact path="/" component={Login} />
            </Switch>
        </BrowserRouter>
    );
}

export default App;